import { configureStore } from '@reduxjs/toolkit';

import layoutReducer from './slices/layout/layout.slice';
import conversationReducer from './slices/conversation/conversation.slice';

export const store = configureStore({
  reducer: {
    layout: layoutReducer,
    conversation: conversationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
